import { RightOutlined } from "@ant-design/icons";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function MenuItem({ name, icon, to }: any) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <Link
      className={`flex items-center  justify-between mb-2 px-2 py-2 rounded-sm ${match ? "bg-karimjee-light" : ""
        }`}
      to={`${to}`}
    >
      <div className="flex items-center">
        {icon}
        <span className="mx-2">{name}</span>
      </div>
      <RightOutlined />
    </Link>
  );
}
